import React, { useState, useEffect } from 'react'
import { getAllData as getClassData } from '../../lib/class'
import { getAllData as getInstructorData } from '../../lib/instructorinfo'
import { getDataWithTypeForSelect } from '../../lib/parameters'
import params from '../../Data/params.json'
import courselevel from '../../Data/courselevel.json'

export function SchoolSelect({ value, setValue }) {
	const [school, setSchool] = useState(null)

	async function getDataWithTypeFromParamter() {
		const slct = await getDataWithTypeForSelect('SCHOOL')
		setSchool(slct)

		if (!value) setValue(slct[0].value)
	}

	useEffect(() => {
		getDataWithTypeFromParamter()
	}, [])

	return (
		<div>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{school?.map(function (data, ix) {
					return (
						<option key={ix} value={data.value}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function ActivitySelect({ value, setValue }) {
	const [lessonType, setLessonType] = useState(null)

	async function getDataWithTypeFromParamter() {
		const slct = await getDataWithTypeForSelect('ACTIVITY')
		setLessonType(slct)
		if (!value) setValue(slct[0].value)
	}

	useEffect(() => {
		getDataWithTypeFromParamter()
	}, [])

	return (
		<div>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{lessonType?.map(function (data, ix) {
					return (
						<option key={ix} value={data.value}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function ChekListTypeSelect({ value, setValue }) {
	const [checkListType, setCheckListType] = useState(null)

	async function getDataWithTypeFromParamter() {
		const slct = await getDataWithTypeForSelect('CHECKLIST')
		setCheckListType(slct)
		if (!value) setValue(slct[0].value)
	}

	useEffect(() => {
		getDataWithTypeFromParamter()
	}, [])

	return (
		<div>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{checkListType?.map(function (data, ix) {
					return (
						<option key={ix} value={data.value}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function ParameterTypeSelect({ value, setValue, page = 'Edit' }) {
	const [pType] = useState(params)

	useEffect(() => {
		if (page === 'Edit') {
			setValue(pType[0].type)
		}
	}, [])

	return (
		<div>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				<option key={0} value="All">
					All
				</option>
				{pType?.map(function (data, ix) {
					return (
						<option key={ix} value={data.type}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function LessonTypeSelect({ value, setValue }) {
	const [lessonType, setLessonType] = useState(null)

	async function getDataWithTypeFromParamter() {
		const slct = await getDataWithTypeForSelect('LESSONTYPE')
		setLessonType(slct)
		if (!value) setValue(slct[0].value)
	}

	useEffect(() => {
		getDataWithTypeFromParamter()
	}, [])

	return (
		<div>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{lessonType?.map(function (data, ix) {
					return (
						<option key={ix} value={data.value}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function TaskTopic911Select({ value, setValue, isDarkMode = false }) {
	const [taskTopic, setTaskTopic] = useState(null)

	async function getDataWithTypeFromParamter() {
		const slct = await getDataWithTypeForSelect('TASKTOPIC911')
		setTaskTopic(slct)
		if (!value) setValue(slct[0].label)
	}

	useEffect(() => {
		getDataWithTypeFromParamter()
	}, [])

	return (
		<div>
			<select
				value={value}
				onChange={(e) => setValue(e.target.value)}
				className="form-control"
				style={{
					backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
					color: isDarkMode ? '#fff' : 'inherit'
				}}
			>
				{taskTopic?.map(function (data, ix) {
					return (
						<option key={ix} value={data.label}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function TaskTopic12Select({ value, setValue, isDarkMode = false }) {
	const [taskTopic, setTaskTopic] = useState(null)

	async function getDataWithTypeFromParamter() {
		const slct = await getDataWithTypeForSelect('TASKTOPIC12')
		setTaskTopic(slct)
		if (!value) setValue(slct[0].label)
	}

	useEffect(() => {
		getDataWithTypeFromParamter()
	}, [])

	return (
		<div>
			<select
				value={value}
				onChange={(e) => setValue(e.target.value)}
				className="form-control"
				style={{
					backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
					color: isDarkMode ? '#fff' : 'inherit'
				}}
			>
				{taskTopic?.map(function (data, ix) {
					return (
						<option key={ix} value={data.label}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function ClassSelect({ value, setValue }) {
	const [classlist, setClassList] = useState([])

	async function GetData() {
		const clas = await getClassData()
		setClassList(clas)
		setValue(clas[0].id)
	}

	useEffect(() => {
		GetData()
	}, [])

	return (
		<div>
			<label className="form-label">Class</label>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{classlist.map(function (data, ix) {
					return (
						<option key={ix} value={data.id}>
							{data.class_name}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function InstructorSelect({ value, setValue }) {
	const [instructorList, setInstructorList] = useState([])

	async function GetData() {
		const instructors = await getInstructorData()
		setInstructorList(instructors)

		setValue(instructors[0].id)
	}

	useEffect(() => {
		GetData()
	}, [])

	return (
		<div>
			<label className="form-label">Instructor</label>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{instructorList.map(function (data, ix) {
					return (
						<option key={ix} value={data.id}>
							{data.name + ' ' + data.surname}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function SubInstructorSelect({ value, setValue, excludeInstructor }) {
	const [subInstructorList, setSubInstructorList] = useState([])

	async function GetData() {
		const subInstructors = await getInstructorData()
		setSubInstructorList(subInstructors)
	}

	useEffect(() => {
		GetData()
	}, [])

	// Filter out the selected instructor from the sub-instructor list
	const filteredSubInstructorList = subInstructorList.filter((subInstructor) => subInstructor.id !== excludeInstructor)

	return (
		<div>
			<label className="form-label">Sub-Instructor</label>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				<option key={0} value={'aaa'}>
					Select
				</option>
				{filteredSubInstructorList.map(function (data, ix) {
					return (
						<option key={ix} value={data.id}>
							{data.name + ' ' + data.surname}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function ClassForTranskriptSelect({ value, setValue }) {
	const [classList] = useState([6, 7, 8, 9, 10, 11, 12])

	if (!value) setValue(6)

	return (
		<div>
			<label className="form-label">Class</label>
			<select
				//name={name}
				value={value}
				onChange={(e) => setValue(e.target.value)}
				className="form-control"
			>
				{classList.map(function (data, ix) {
					return (
						<option key={ix} value={data}>
							{data}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function ClassForLessonSelect({ value, name, setValue }) {
	const [classList] = useState([6, 7, 8, 9, 10, 11, 12])

	if (!value) setValue(9)

	return (
		<div>
			<label className="form-label">Grade</label>
			<select name={name} value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{classList.map(function (data, ix) {
					return (
						<option key={ix} value={data}>
							{data}
						</option>
					)
				})}
			</select>
		</div>
	)
}

const ACTIVITY_GRADE_OPTIONS = ['9', '10', '11', '12']

/** Parse stored gradelevel (comma-separated and/or legacy range like 9-11) into a Set of '9'..'12'. */
export function parseStoredActivityGrades(stored) {
	const set = new Set()
	if (stored == null || String(stored).trim() === '') return set
	const str = String(stored).trim()
	if (str.includes(',')) {
		for (const p of str.split(',')) {
			const t = p.trim()
			if (ACTIVITY_GRADE_OPTIONS.includes(t)) set.add(t)
		}
		if (set.size > 0) return set
	}
	const range = str.match(/^(\d+)-(\d+)$/)
	if (range) {
		let a = parseInt(range[1], 10)
		let b = parseInt(range[2], 10)
		if (Number.isNaN(a) || Number.isNaN(b)) return set
		if (a > b) [a, b] = [b, a]
		for (let g = a; g <= b; g++) {
			if (g >= 9 && g <= 12) set.add(String(g))
		}
		return set
	}
	if (ACTIVITY_GRADE_OPTIONS.includes(str)) set.add(str)
	return set
}

export function serializeActivityGrades(set) {
	return ACTIVITY_GRADE_OPTIONS.filter((g) => set.has(g)).join(',')
}

/** Activities: grades 9–12 as checkboxes; persisted in the same DB field, comma-separated (e.g. "9,10,12"). */
export function ClassForLessonSelectForActivities({ value, name = 'gradelevel', label = 'Grade', setValue, disabled = false }) {
	const selected = parseStoredActivityGrades(value)

	const toggle = (g) => {
		const next = new Set(selected)
		if (next.has(g)) next.delete(g)
		else next.add(g)
		setValue(serializeActivityGrades(next))
	}

	return (
		<div>
			<label className="form-control-label fw-bold mb-2 d-block">{label}</label>
			<div
				className="border-radius-10 p-3"
				style={{
					border: '1px solid #e9ecef',
					boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
				}}
			>
				<div className="d-flex flex-wrap align-items-center gap-4" role="group" aria-label={label}>
					{ACTIVITY_GRADE_OPTIONS.map((g) => {
						const id = `${name}-activity-grade-${g}`
						return (
							<div key={g} className="form-check d-flex align-items-center mb-0 py-1">
								<input
									className="checkbox_animated"
									type="checkbox"
									id={id}
									checked={selected.has(g)}
									onChange={() => toggle(g)}
									disabled={disabled}
								/>
								<label
									className="form-check-label ms-2 mb-0"
									htmlFor={id}
									style={{ cursor: disabled ? 'default' : 'pointer' }}
								>
									{g}
								</label>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}

export function MonthsForGradesSelect({ value, name = 'month', setValue }) {
	const [monthList] = useState(['September', 'October', 'November', 'December', 'January', 'February', 'March', 'April', 'May', 'June'])

	return (
		<div>
			<label className="form-label">Month</label>
			<select name={name} value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{monthList.map(function (data, ix) {
					return (
						<option key={ix} value={data}>
							{data}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function RoleSelect({ value, name = 'role', setValue }) {
	const [roleList] = useState(['Student911', 'Student12'])

	return (
		<div>
			<label className="form-label">Role</label>
			<select name={name} value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{roleList.map(function (data, ix) {
					return (
						<option key={ix} value={data}>
							{data}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function RoleSelectforNewRecord({ value, name = 'role', setValue }) {
	const [roleList] = useState(['Student911', 'Student12'])

	useEffect(() => {
		setValue(roleList[0])
	}, [])

	return (
		<div>
			<label className="form-label">Role</label>
			<select name={name} value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{roleList.map(function (data, ix) {
					return (
						<option key={ix} value={data}>
							{data}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function RecognitionLevelSelect({ value, setValue }) {
	const [recoglevel] = useState(['State', 'National', 'International', 'Regional', 'City', 'School'])

	if (!value) setValue('Local')

	return (
		<div>
			<label className="form-label">Recognition Level</label>
			<select
				//name={name}
				value={value}
				onChange={(e) => setValue(e.target.value)}
				className="form-control"
			>
				{recoglevel.map(function (data, ix) {
					return (
						<option key={ix} value={data}>
							{data}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function ActivityTierSelect({ value, setValue }) {
	const tiers = ['1', '2', '3', '4']

	return (
		<div>
			<label className="form-control-label fw-bold mb-2 d-block">Tier</label>
			<select value={value ?? ''} onChange={(e) => setValue(e.target.value)} className="form-control border-radius-10">
				<option value="">Select tier</option>
				{tiers.map((t) => (
					<option key={t} value={t}>
						{t}
					</option>
				))}
			</select>
		</div>
	)
}

export function ActivityRowStatusSelect({ value, setValue }) {
	const options = ['New', 'Current', 'Done']

	return (
		<div>
			<label className="form-control-label fw-bold mb-2 d-block">Status</label>
			<select value={value ?? ''} onChange={(e) => setValue(e.target.value)} className="form-control border-radius-10">
				<option value="">Select status</option>
				{options.map((o) => (
					<option key={o} value={o}>
						{o}
					</option>
				))}
			</select>
		</div>
	)
}

export function CourseDepartmentSelect({ value, name = 'department', setValue }) {
	const [deptList] = useState(['English', 'Math', 'Science', 'Social Studies', 'F. Language', 'PE/Art/Music', 'Electives', 'Business', 'Computer'])

	return (
		<div>
			<label className="form-label">Department</label>
			<select name={name} value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{deptList.map(function (data, ix) {
					return (
						<option key={ix} value={data}>
							{data}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function CourseLevelSelect({ value, name = 'level', setValue }) {
	const [levelList] = useState(courselevel)

	return (
		<div>
			<label className="form-label">Level</label>
			<select name={name} value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{levelList.map(function (data, ix) {
					return (
						<option key={ix} value={data.value}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

export function CourseApScoreSelect({ value, name = 'apscore', setValue }) {
	const [apScoreList] = useState([0, 1, 2, 3, 4, 5])

	if (!value) setValue(9)

	return (
		<div>
			<label className="form-label">AP Score</label>
			<select name={name} value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{apScoreList.map(function (data, ix) {
					return (
						<option key={ix} value={data}>
							{data}
						</option>
					)
				})}
			</select>
		</div>
	)
}

// category select
export function CategorySelectForActivity({ value, setValue, hideLabel = false }) {
	const [categoryList] = useState([
		{ label: 'Academic/Research/Publication', value: 'A/R/P' },
		{ label: 'Career-Oriented', value: 'Career' },
		{ label: 'Internship', value: 'Intern' },
		{ label: 'Community Service', value: 'Service' },
		{ label: 'Debate/Speech/Student Govt', value: 'Db/Gov' },
		{ label: 'Athletics Team', value: 'Sports' },
		{ label: 'Art/Music/Theater/Dance', value: 'Arts' },
		{ label: 'Family Responsibility', value: 'Family' },
		{ label: 'Work', value: 'Work' },
		{ label: 'Others/Clubs', value: 'Clubs' }
	])

	if (!value) {
		setValue(categoryList[0].value)
	}

	return (
		<div>
			{!hideLabel && <label className="form-control-label fw-bold mb-2 d-block">Category</label>}
			<select
				value={value}
				onChange={(e) => {
					console.log('Category selected:', e.target.value)
					setValue(e.target.value)
				}}
				className="form-control border-radius-10"
			>
				{categoryList.map(function (data, ix) {
					return (
						<option key={ix} value={data.value}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

// position select
export function PositionSelectForActivity({ value, setValue, hideLabel = false }) {
	const [positionList] = useState([
		{ label: 'Founder', value: '1.FDR' },
		{ label: 'President', value: '2.PRS' },
		{ label: 'Officer', value: '3.OFC' },
		{ label: 'Organizer', value: '4.ORG' },
		{ label: 'Helper', value: '5.HLP' },
		{ label: 'Member', value: '6.MBR' }
	])

	if (!value) {
		setValue(positionList[0].value)
	}

	return (
		<div>
			{!hideLabel && <label className="form-control-label fw-bold mb-2 d-block">Position</label>}
			<select
				value={value}
				onChange={(e) => {
					console.log('Position selected:', e.target.value)
					setValue(e.target.value)
				}}
				className="form-control border-radius-10"
			>
				{positionList.map(function (data, ix) {
					return (
						<option key={ix} value={data.value}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}

// ranking select
export function RankingSelect({ value, setValue }) {
	const [rankingList] = useState([
		{ label: '1 or 2', value: '1 or 2' },
		{ label: '3 or 4', value: '3 or 4' },
		{ label: '5 or 6', value: '5 or 6' },
		{ label: '7 or More', value: '7 or More' },
		{ label: 'Certificate', value: 'Certificate' },
		{ label: 'Participation', value: 'Participation' }
	])

	if (!value) {
		setValue(rankingList[0].value)
	}

	return (
		<div>
			<label className="form-label">Ranking</label>
			<select value={value} onChange={(e) => setValue(e.target.value)} className="form-control">
				{rankingList.map(function (data, ix) {
					return (
						<option key={ix} value={data.value}>
							{data.label}
						</option>
					)
				})}
			</select>
		</div>
	)
}
